<template>
  <div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Approve Proposed Products</p>
      </header>
      <section class="modal-card-body">
        <p class="pa-xl has-text-grey has-text-centered">
          You are about to approve <b>{{ this.proposals.length }}</b> {{ (this.proposals.length === 1) ? "proposal" :
          "proposals" }}.
          Once approved, the proposals will move forward in the workflow and cannot be edited.
          Are you sure you want to continue?
        </p>
      </section>
      <footer class="modal-card-foot space-between">
        <b-button @click="$parent.close()">Close</b-button>
        <b-button type="is-primary" :disabled="saving" :loading="saving" @click="approveProposal">Approve</b-button>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {
  },
  computed: {
    ...mapGetters(['app', 'context']),
    endpoint () {
      return `${this.context.route}/proposals/bulk-approve/`
    },
    json () {
      const json = {
        proposal_ids: this.proposals.map(proposal => proposal.id)
      }
      return json
    }
  },
  data () {
    return {
      saving: false,
      found: null,
      success: null,
      failed: null,
      errors: null
    }
  },
  methods: {
    approveProposal () {
      this.saving = true
      this.$http.post(this.endpoint, this.json).then(response => {
        this.$buefy.toast.open({ type: 'is-success', message: 'Proposals Approved' })
        this.found = response.data.total_found
        this.successs = response.data.total_success
        this.failed = response.data.total_failure
        this.errors = response.data.errors
        this.closeAndReload()
      }).catch(error => {
        this.$buefy.toast.open({ type: 'is-danger', message: 'An error occurred! Please check your input and try again!' })
        this.errors = (error.response.data) ? error.response.data : { detail: 'An unexpected error occured!' }
      }).finally(() => {
        this.processing = false
      })
    },
    closeAndReload () {
      this.$emit('reload')
      this.$parent.close()
    }
  },
  mounted () {
  },
  props: {
    proposals: {
      type: Array,
      required: true
    }
  }
}
</script>
